export default "__VITE_ASSET__CcfvX6Lk__"